module.exports = __webpack_public_path__ + "static/espruar-alphabet-SCAG-c53a4184a04297de0826ee76bed29998.jpg";